<template>
  <div class="main-page scrollbar">
    <div class="form-container">
      <h1>Add New User</h1>
      <div class="form-row mt-3">
        <label class="label required">First Name</label>
        <div class="value">
          <input
            v-model="firstname"
            class="select"
            type="text"
            :class="{ 'error' : errorFirstName }"
          >
        </div>
      </div>
      <div class="form-row mt-3">
        <label class="label required">Last Name</label>
        <div class="value">
          <input
            v-model="lastname"
            class="select"
            type="text"
            :class="{ 'error' : errorLastName }"
          >
        </div>
      </div>
      <div class="form-row mt-3">
        <label class="label required">New Username</label>
        <div class="value">
          <input
            v-model="username"
            class="select"
            type="text"
            :class="{ 'error' : errorUsername }"
          >
        </div>
      </div>
      <div class="form-row mt-3">
        <label class="label required">Password</label>
        <div class="value">
          <input
            v-model="password"
            class="select"
            type="password"
            :class="{ 'error' : errorPassword }"
          >
        </div>
      </div>
      <div class="form-row mt-3">
        <label class="label required">Confirm Password</label>
        <div class="value">
          <input
            v-model="confirmPassword"
            class="select"
            type="password"
            :class="{ 'error' : errorConfirmPassword }"
          >
        </div>
      </div>
      <div class="form-row mt-3">
        <label class="label required">Email</label>
        <div class="value">
          <input
            v-model="email"
            class="select"
            type="text"
            :class="{ 'error' : errorEmail }"
          >
        </div>
      </div>
      <div class="form-row mt-3">
        <label class="label">Role</label>
        <div class="value permission-list">
          <div class="role-grid-single-row">
            <div class="chkbx-li">
              <v-checkbox
                v-model="presetRole"
                :hide-details="true"
                density="compact"
                value="admin"
              >
                <template #label>
                  <div class="label-text">Admin</div>
                </template>
              </v-checkbox>
              <span class="chkbx-li__subtitle">User will have permission to make changes to organization settings such as purchase credits, create public datasets, or add new users.</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="message" class="form-row mt-3">
        <label class="label" />
        <div class="value" :class="{ 'error-text': isError, 'success-text' : !isError }">{{ message }}</div>
      </div>
      <div class="row mt-3 form-footer">
        <button class="button button-sm rounded" @click.stop="createUser">Add</button>
        <span @click.stop="$router.go(-1)">Back</span>
      </div>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

export default {
  name: 'CreateSecondaryUser',
  components: {
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      password: '',
      errorPassword: false,
      confirmPassword: '',
      errorConfirmPassword: false,
      username: '',
      errorUsername: false,
      firstname: '',
      errorFirstName: false,
      lastname: '',
      errorLastName: false,
      allRoles: [],
      message: '',
      errorRole: false,
      email: '',
      errorEmail: false,
      backendError: false,
      organization_id: 0,
      presetRole: null,
    };
  },
  computed: {
    isError() {
      return this.errorPassword || this.errorUsername || this.errorFirstName || this.errorLastName || this.errorRole || this.errorEmail || this.backendError || this.errorConfirmPassword;
    },
    user() {
      return this.$store.state.user.user;
    },
    isSuper() {
      return this.user.role === 'super';
    },
    isAdmin() {
      return this.user.role === 'admin';
    },
  },
  watch: {
  },
  created() {
    if (this.$route.query.org) {
      this.organization_id = parseInt(this.$route.query.org);
    } else {
      this.$router.go(-1);
    }
    if (!this.isAdmin && !this.isSuper) {
      this.$router.push('/login');
    }
  },
  methods: {
    resetErrors() {
      this.errorUsername = false;
      this.errorLastName = false;
      this.errorLastName = false;
      this.errorRole = false;
      this.errorConfirmPassword = false;
      this.errorPassword = false;
      this.errorEmail = false;
      this.backendError = false;
    },
    async createUser() {
      this.resetErrors();
      this.message = "";
      if (!this.username) {
        this.errorUsername = true;
        this.message = 'Missing username.';
        return;
      }
      if (!this.firstname) {
        this.errorFirstName = true;
        this.message = 'Missing first name.';
        return;
      }
      if (!this.lastname) {
        this.errorLastName = true;
        this.message = 'Missing last name.';
        return;
      }
      if (!this.password) {
        this.errorPassword = true;
        this.message = 'Missing password.';
        return;
      }
      if (!this.confirmPassword) {
        this.errorConfirmPassword = true;
        this.message = 'Missing confirm password.';
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.errorPassword = true;
        this.errorConfirmPassword = true;
        this.message = 'Confirm password does not match password.';
        return;
      }
      if (!this.email) {
        this.errorEmail = true;
        this.message = 'Missing email.';
        return;
      }

      const params = {
        organization_id: this.organization_id,
        username: this.username,
        last_name: this.lastname,
        first_name: this.firstname,
        password: this.password,
        email: this.email,
        role: this.presetRole,
      };

      let message = '';

      await this.dsConn.createUser(params)
        .then(async (data) => {
          if (!data.error) {
            message = `User ${this.username} added successfully.`;
          } else {
            this.backendError = true;
            message = data.error.message;
          }
        })
        .catch((e) => {
          this.backendError = true;
          message = e;
        });
      this.message = message;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  margin: 30px;
}



.header {
  font-size: 1.2rem;
  font-weight: 700;
}


.role-grid-single-row {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
}


.permission-list {
  display: flex;
  flex-direction: column !important;
  width: 100%;

  &__title {
    margin: 5px 0 5px 0;
    font-size: 1rem;
    font-weight: 600;
    color: rgba(rgb(0, 0, 0), 0.7);
  }
}

.chkbx-li {
  display: flex;
  flex-direction: column;
  align-items: start;

  &__subtitle {
    margin-left: 30px;
    color: rgba(grey, 0.95);
  }
}

.role-grid {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: auto;
  width: 100%;
}

</style>
